'use client'

import { Button, Container, Dialog, Image, Spacer, Text } from '@vinted/web-ui'

import { useIsDarkMode } from '@marketplace-web/dark-mode/dark-mode-feature'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { CDN_IMAGES_URL } from '@marketplace-web/shared/assets'

type Props = { handleClose: () => void } & React.ComponentProps<typeof Dialog>

const FormSuccessModal = ({ closeOnOverlay = true, handleClose, ...props }: Props) => {
  const isDarkMode = useIsDarkMode()
  const translate = useTranslate('advertising.form.success_message')

  const iconPath = `${CDN_IMAGES_URL}/landing/advertising/check-circle${
    isDarkMode ? '_dark' : ''
  }.svg`

  return (
    <Dialog
      testId="advertising-form-success-modal"
      closeOnOverlay={closeOnOverlay}
      defaultCallback={handleClose}
      {...props}
    >
      <Container>
        <div className="u-flexbox u-align-items-center u-flex-direction-column">
          <Image src={iconPath} size="large" alt="" testId="advertising-form-success-modal-image" />
          <Spacer size="large" />
          <Text as="h1" text={translate('title')} type="heading" alignment="center" />
        </div>
        <Spacer size="large" />
        <Text as="span" text={translate('subtitle')} alignment="center" />
        <Spacer size="x2-large" />
        <Button theme="primary" styling="filled" text={translate('close')} onClick={handleClose} />
      </Container>
    </Dialog>
  )
}

export default FormSuccessModal
